import { type TypedDocumentNode, gql } from '@apollo/client';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { EmirateCupBanner } from '../EmirateCupBanner';
import { TodaysCompetition } from '../TodaysCompetition';
import type { DailyHoopsBanner_so5Fixture } from './__generated__/index.graphql';

type Props = { fixture: DailyHoopsBanner_so5Fixture };

export const DailyHoopsBanner = ({ fixture }: Props) => {
  if (!fixture.event) return null;
  if (fixture.eventType.toUpperCase() !== So5FixtureEvent.DAILY) return null;

  if (fixture.eventName === 'emirates_nba_cup') {
    return <EmirateCupBanner event={fixture.event} />;
  }
  return <TodaysCompetition event={fixture.event} />;
};

DailyHoopsBanner.fragments = {
  so5Fixture: gql`
    fragment DailyHoopsBanner_so5Fixture on So5Fixture {
      slug
      eventType
      eventName
      event {
        ...EmirateCupBanner_Event
        ...TodaysCompetition_Event
      }
    }
    ${EmirateCupBanner.fragments.Event}
    ${TodaysCompetition.fragments.Event}
  ` as TypedDocumentNode<DailyHoopsBanner_so5Fixture>,
};
